export const mutations = {
    setMedia(state, media) {
        state.media = media;
    },
};